define(() => {
    "use strict";

    /**
     * Maps currency
     *
     * @class CurrencyMapper
     * @constructor
     */
    return {

        _currencyMap: new Map([["en-US", "$"]]),

        getCurrencyMapping(language) {
            if (this._currencyMap.has(language)) {
                return this._currencyMap.get(language);
            }
            throw new Error("Unsupported Language for Product Widget");
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/dynamicProductWidget/CurrencyMapper.js